<template>
  <div>
    <loading :active.sync="is_loading"></loading>
    <Product v-show="!is_loading" :id="idProducto" @loader="changeLoader" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import Product from "../views/Product.vue";

export default {
  props: ["id"],
  name: "LoaderProduct",
  components: {
    Loading,
    Product,
  },
  data() {
    return {
      is_loading: false,
      idProducto: "",
    };
  },
  created() {
    this.idProducto = this.id;
  },
  mounted() {
    this.changeLoader();
  },
  methods: {
    changeLoader() {
      setTimeout(() => {
        this.is_loading = false;
      }, 3800);
    },
  },
};
</script>

<style>
</style>